import { TTeamObject } from '../../types/teamTypes';
import { safeCharacterName } from '../../common/utils';
import { resolveRoutePath } from '../bundles/routes';

export function getTeamLink(route: string, team: TTeamObject) {
  const members = team.members.map((m: any) => safeCharacterName(m.character.name)).join('-');
  return resolveRoutePath(route, { id: members.length > 0 ? `${team.id}-${members}` : `${team.id}` });
}
